import React, { useState } from "react"
import styled, { css } from "styled-components"
import { useParts } from "../provider/PartsContext"
const ToggleInfoPanelButtonWrapper = styled.div`
  position: absolute;
`
const ToggleInfoPanelButton = () => {
  const { setVisible, visible } = useParts()
  const toggleVisibility = () => {
    setVisible((prevVisible) => !prevVisible)
  }
  return (
    <>
      <ToggleInfoPanelButtonWrapper visible={visible}>
        <button onClick={toggleVisibility}>{visible ? "非表示" : "表示"}</button>
      </ToggleInfoPanelButtonWrapper>
    </>
  )
}
export default ToggleInfoPanelButton
